import { motion } from 'framer-motion';
import CareerHero from '../components/careers/CareerHero';
import WhyJoinUs from '../components/careers/WhyJoinUs';
import OpenPositions from '../components/careers/OpenPositions';
import TeamTestimonials from '../components/careers/TeamTestimonials';

export default function Careers() {
  return (
    <div className="bg-white">
      <section className="relative h-[200px] overflow-hidden">
        <motion.div
          initial={{ scale: 1.1, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 1.5, ease: "easeOut" }}
          className="absolute inset-0"
        >
          <img
            src="https://images.unsplash.com/photo-1573165706511-3ffde6ef1fe3?q=80&w=2938&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
            alt="Professional black women in business meeting"
            className="w-full h-full object-cover object-[50%_30%]"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 to-black/70" />
        </motion.div>
        
        <motion.div 
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.5 }}
          className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-center text-center"
        >
          <div>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-2">
              Join Our Team
            </h1>
            <p className="text-lg text-white/90 max-w-2xl mx-auto">
              Build your career with a purpose-driven organization
            </p>
          </div>
        </motion.div>
      </section>

      <CareerHero />
      <WhyJoinUs />
      <OpenPositions />
      <TeamTestimonials />
    </div>
  );
}